module.exports = __webpack_public_path__ + "static/media/img141.8dada448.jpg";